import {WikiDocument} from "../../../components/wiki/wiki_document";
import {SECTION_HR} from "../../../components/wiki/sections";

/** Formación: la página de la wiki de RR. HH. que la describe, como documento. */
export const EmployeeLearningPage = () => (
	<WikiDocument code="emp.learning.home" section={SECTION_HR}
				  title="Formación" subtitle="Cursos, certificaciones y cómo pedir formación."/>
);
